"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureDataTable = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _reactBootstrapTable = require("react-bootstrap-table");
var _Skeleton = _interopRequireDefault(require("@mui/material/Skeleton"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactJsPagination = _interopRequireDefault(require("react-js-pagination"));
require("react-bootstrap-table/css/react-bootstrap-table.css");
var _index = _interopRequireDefault(require("../externalPagination/index"));
var _editableCell = _interopRequireDefault(require("./editableCell"));
var _resizeable = _interopRequireDefault(require("./resizeable"));
var _styles = _interopRequireDefault(require("./styles.scss"));
var _resizeCell = _interopRequireDefault(require("./resizeCell"));
var _helpTip = _interopRequireDefault(require("../helpTip"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CLASS_NAME = _styles.default['datatable-container'];
var PINTABLE_CLASS_NAME = _lodash.default.get(_styles.default, 'pinned-table', 'pinned-table');
var defaultCaret = function defaultCaret(direction) {
  var caretOptions = {
    asc: /*#__PURE__*/_react.default.createElement("span", {
      className: "default-caret"
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      className: "black-caret",
      icon: _freeSolidSvgIcons.faCaretUp
    })),
    desc: /*#__PURE__*/_react.default.createElement("span", {
      className: "default-caret"
    }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      className: "black-caret",
      icon: _freeSolidSvgIcons.faCaretDown
    }))
  };
  var unsorted = /*#__PURE__*/_react.default.createElement("span", {
    className: "default-caret"
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCaretUp
  }), /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCaretDown
  }));
  return caretOptions[direction] || unsorted;
};
var DataTable = /*#__PURE__*/function (_Component, _componentDidUpdate) {
  (0, _inherits2.default)(DataTable, _Component);
  var _super = _createSuper(DataTable);
  function DataTable(_props) {
    var _this;
    (0, _classCallCheck2.default)(this, DataTable);
    _this = _super.call(this, _props);
    /**
     * Wrapper cell editor inside ResizeCell
     * @param {Element}
     * @returns
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderCustomEditor", function (o) {
      if (o.customEditor) {
        return {
          getElement: function getElement(onUpdate, props) {
            return /*#__PURE__*/_react.default.createElement(_resizeCell.default, {
              celleditor: o,
              tableRef: _this.pinnedTableRef,
              onUpdate: onUpdate,
              infos: props
            });
          }
        };
      }
      return null;
    });
    _this.pinnedTableRef = /*#__PURE__*/_react.default.createRef();
    _this.movableTableRef = /*#__PURE__*/_react.default.createRef();
    _this.state = {
      activePage: 1,
      currtarget: null,
      cellinfo: null,
      data: [],
      columns: [{
        isPrimaryKey: true,
        key: 'a'
      }],
      showTooltip: false,
      selectedRow: null,
      loading: true,
      dividerHeight: 0
    };
    _this.paginationPanel = _this.paginationPanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTooltip = _this.handleTooltip.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderColumns = _this.renderColumns.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderHeader = _this.renderHeader.bind((0, _assertThisInitialized2.default)(_this));
    _this.movableColumns = [];
    _this.renderTable = _this.renderTable.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSortChange = _this.onSortChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderMovableColumns = _this.renderMovableColumns.bind((0, _assertThisInitialized2.default)(_this));
    _this.getSortedData = _this.getSortedData.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRowMouseOver = _this.onRowMouseOver.bind((0, _assertThisInitialized2.default)(_this));
    _this.onRowMouseOut = _this.onRowMouseOut.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFormatTrClass = _this.onFormatTrClass.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderExternalPagination = _this.renderExternalPagination.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDeleteRow = _this.onDeleteRow.bind((0, _assertThisInitialized2.default)(_this));
    _this.afterSaveCell = _this.afterSaveCell.bind((0, _assertThisInitialized2.default)(_this));
    _this.setDividerHeight = _this.setDividerHeight.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(DataTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onLoadData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_x) {
      return (_componentDidUpdate = _componentDidUpdate || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        var pinRefHeight;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              pinRefHeight = this.pinnedTableRef.current ? this.pinnedTableRef.current.table.offsetHeight : 0;
              if (this.state.dividerHeight !== pinRefHeight) {
                this.setDividerHeight();
              }
              if (!(prevProps.data !== this.props.data || prevProps.columns !== this.props.columns || prevProps.requesting !== this.props.requesting)) {
                _context.next = 5;
                break;
              }
              _context.next = 5;
              return this.onLoadData();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }))).apply(this, arguments);
    }
  }, {
    key: "onLoadData",
    value: function onLoadData() {
      var _this$props = this.props,
        data = _this$props.data,
        columns = _this$props.columns,
        requesting = _this$props.requesting;
      var tempData = data && (0, _toConsumableArray2.default)(data);
      var tempColumns = (0, _toConsumableArray2.default)(columns);
      var loading = true;
      if (!data || data.length < 1) {
        if (requesting) {
          tempData = [{
            a: 1
          }, {
            b: 2
          }, {
            c: 3
          }, {
            d: 4
          }, {
            e: 5
          }];
          tempColumns = columns && columns.length > 0 ? columns.map(function (c) {
            return _objectSpread(_objectSpread({}, c), {}, {
              tooltipOff: true
            });
          }) : [{
            tooltipOff: true,
            key: 'a',
            isPrimarykey: true
          }, {
            tooltipOff: true,
            key: 'b'
          }, {
            tooltipOff: true,
            key: 'c'
          }, {
            tooltipOff: true,
            key: 'd'
          }, {
            tooltipOff: true,
            key: 'e'
          }];
        }
      } else {
        loading = false;
      }
      if (!requesting) {
        loading = false;
      }
      if (!this.props.serverPagination && !loading) {
        tempData = this.getSortedData();
      }
      this.setState({
        data: tempData,
        columns: tempColumns,
        loading: loading
      });
    }
  }, {
    key: "onSortChange",
    value: function onSortChange(sortName, sortOrder) {
      var _this2 = this;
      var data = this.props.data;
      var sortingdata = [];
      var nullData = [];
      if (data && Array.isArray(data) && data.length > 0) {
        nullData = data.filter(function (d) {
          if (!_lodash.default.isNil(d[sortName])) {
            sortingdata.push(d);
            return false;
          }
          return true;
        });
      }
      var collator = new Intl.Collator(undefined, {
        sensitivity: 'base',
        numeric: true
      });
      sortingdata.sort(function (a, b) {
        if (sortOrder === 'asc') {
          return collator.compare(a[sortName], b[sortName]);
        }
        return collator.compare(b[sortName], a[sortName]);
      });
      if (nullData.length > 0) {
        sortingdata.push.apply(sortingdata, (0, _toConsumableArray2.default)(nullData));
      }
      this.setState({
        data: sortingdata,
        sortName: sortName,
        sortOrder: sortOrder
      }, function () {
        return _this2.props.sortChangeCallback(sortName, sortOrder, sortingdata);
      });
      return sortingdata;
    }
  }, {
    key: "onRowMouseOver",
    value: function onRowMouseOver(row) {
      this.setState({
        selectedRow: row
      });
    }
  }, {
    key: "onRowMouseOut",
    value: function onRowMouseOut() {
      this.setState({
        selectedRow: null
      });
    }
  }, {
    key: "onFormatTrClass",
    value: function onFormatTrClass(row) {
      if (this.props.onCustomFormatTrClass !== undefined) {
        return this.props.onCustomFormatTrClass(row, this.state.selectedRow);
      }
      return (row && row.id) === (this.state.selectedRow && this.state.selectedRow.id) ? 'hover' : '';
    }
  }, {
    key: "onDeleteRow",
    value: function onDeleteRow(rows) {
      var primaryCol = this.props.columns.filter(function (c) {
        return c.isPrimaryKey;
      })[0];
      var primaryKey = primaryCol && primaryCol.key;
      var currentData = (0, _toConsumableArray2.default)(this.state.data);
      var filteredData = currentData.filter(function (d) {
        return !rows.includes(d[primaryKey]);
      });
      this.props.options.onDeleteRow(rows, filteredData);
    }
  }, {
    key: "setDividerHeight",
    value: function setDividerHeight() {
      var dividerHeightChecker = this.pinnedTableRef.current;
      var dividerHeight = dividerHeightChecker ? dividerHeightChecker.table.offsetHeight : 0;
      if (this.state.dividerHeight !== dividerHeight) {
        this.setState({
          dividerHeight: dividerHeight
        });
      }
      if (this.props.data && this.props.data.length === 0 || !this.props.data) {
        return 0;
      }
      return dividerHeight;
    }
  }, {
    key: "getSortedData",
    value: function getSortedData() {
      var _this$props2 = this.props,
        options = _this$props2.options,
        data = _this$props2.data;
      var _this$state = this.state,
        sortName = _this$state.sortName,
        sortOrder = _this$state.sortOrder,
        initialsort = _this$state.initialsort;
      var dataToReturn = data ? (0, _toConsumableArray2.default)(data) : [];
      var sortDataFunc = options.onSortChange || this.onSortChange;
      if (!_lodash.default.isEmpty(options) && !_lodash.default.isNil(options.defaultSortName && !initialsort)) {
        dataToReturn = sortDataFunc(sortName || options.defaultSortName, sortOrder || options.defaultSortOrder, data);
      }
      return dataToReturn;
    }
  }, {
    key: "afterSaveCell",
    value: function afterSaveCell(row, name, value) {
      var primaryCol = this.props.columns.filter(function (c) {
        return c.isPrimaryKey;
      })[0];
      var primaryKey = primaryCol && primaryCol.key;
      var nextData = (0, _toConsumableArray2.default)(this.state.data);
      nextData.forEach(function (d, index) {
        if (d[primaryKey] === row[primaryKey]) {
          nextData[index] = _objectSpread({}, nextData[index]);
          nextData[index][name] = value;
        }
      });
      if (this.props.cellEdit && this.props.cellEdit.afterSaveCell) {
        this.props.cellEdit.afterSaveCell(row, name, value, nextData);
      }
    }
  }, {
    key: "formatEditColumn",
    value: function formatEditColumn(column) {
      var _this3 = this;
      return _objectSpread(_objectSpread({}, column), {}, {
        formatter: function formatter(cell, row) {
          return /*#__PURE__*/_react.default.createElement(_editableCell.default, {
            key: cell && cell.value || cell,
            cell: cell,
            row: row,
            formatter: column.formatter,
            onEdit: _this3.props.onEdit,
            listMode: _this3.props.listMode,
            customRowAction: _this3.props.customRowAction
          });
        }
      });
    }
  }, {
    key: "handleTooltip",
    value: function handleTooltip(event, cellref, cell, index, tooltipFormatter, row, tooltipOff) {
      var currentTarget = event.currentTarget,
        target = event.target;
      var openttip = null;
      var cellset = cell && cell.value ? cell.value : cell;
      var diff = currentTarget.scrollHeight - currentTarget.offsetHeight;
      var parentdiff = target.scrollHeight - target.offsetHeight;
      if ((diff > 2 || parentdiff > 2) && cellset !== undefined) {
        openttip = true;
      } else {
        openttip = false;
      }

      // turns off this overlay
      if (tooltipOff) {
        openttip = false;
      } else if (tooltipFormatter) {
        cellset = tooltipFormatter(cellset, row);
      }
      // to customize this overlay's text display.
      // In case raw data needs formatting, send in the formatted.
      if (target.dataset.cellinfo) {
        cellset = target.dataset.cellinfo;
      }
      var tooltipOrientation = this.props.tooltipOrientation;
      var sizePerPage = this.props.options.sizePerPage;
      var pagediff = sizePerPage * this.state.activePage - this.state.data.length;
      if (index > sizePerPage / 2 || this.state.data.length < 10 || pagediff > sizePerPage / 2 && pagediff < sizePerPage) {
        if (tooltipOrientation.includes('bottom')) {
          tooltipOrientation = tooltipOrientation.replace('bottom', 'top');
        }
      }
      if (openttip) {
        this.setState({
          showTooltip: openttip,
          currtarget: cellref.current,
          cellinfo: cellset,
          tooltipOrientation: tooltipOrientation
        });
      } else {
        this.setState({
          showTooltip: openttip
        });
      }
    }

    // fyi: you must immediately change to page 1 AND change size of data when searching.
  }, {
    key: "paginationPanel",
    value: function paginationPanel(pgprops) {
      var _this4 = this;
      var options = this.props.options;
      var page = options.page;
      var pageToUse = page || this.state.activePage;
      pgprops.changePage(pageToUse);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "paginatorpanel"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "totalrecords"
      }, pgprops.components.totalText), /*#__PURE__*/_react.default.createElement("div", {
        className: "paginator"
      }, /*#__PURE__*/_react.default.createElement(_reactJsPagination.default, {
        activePage: pageToUse,
        itemsCountPerPage: options.sizePerPage,
        totalItemsCount: this.props.data.length,
        pageRangeDisplayed: 5,
        prevPageText: "\u2039",
        nextPageText: "\u203A",
        onChange: function onChange(pagenum) {
          _this4.setState({
            activePage: pagenum
          }, _this4.props.onChangeCurrentPage(pagenum));
        }
      })));
    }
  }, {
    key: "renderTable",
    value: function renderTable(columns, customOptions, isPinned) {
      var _this5 = this;
      var _this$props3 = this.props,
        options = _this$props3.options,
        cellEdit = _this$props3.cellEdit,
        pinTable = _this$props3.pinTable;
      var _this$state2 = this.state,
        data = _this$state2.data,
        pagedata = _this$state2.pagedata,
        loading = _this$state2.loading;
      var tableOptions = _objectSpread({}, options);
      tableOptions = _objectSpread(_objectSpread({}, tableOptions), {}, {
        onDeleteRow: this.onDeleteRow,
        onRowMouseOver: this.onRowMouseOver,
        onRowMouseOut: this.onRowMouseOut,
        sortName: this.state.sortName,
        sortOrder: this.state.sortOrder,
        onSortChange: options.onSortChange ? function (sortName, sortOrder) {
          var outerSortedData = options.onSortChange(sortName, sortOrder, _this5.props.data);
          if (outerSortedData) {
            _this5.setState({
              data: outerSortedData,
              sortName: sortName,
              sortOrder: sortOrder
            });
          } else {
            _this5.setState({
              sortName: sortName,
              sortOrder: sortOrder
            });
          }
        } : this.onSortChange
      }, customOptions);
      // only if search returns no data
      var useNoDataCont = false;
      if (!loading && (!data || data && !data.length > 0)) {
        useNoDataCont = true;
      }
      var finalCellEdit = loading ? false : _objectSpread(_objectSpread({}, cellEdit), {}, {
        afterSaveCell: this.afterSaveCell
      });
      // overwrite props select row for child table in pintable
      var selectRowProp = _objectSpread(_objectSpread({}, this.props.selectRow), {}, {
        // enable hide selection column.
        hideSelectColumn: tableOptions.isMovableColumn,
        clickToSelect: !tableOptions.isMovableColumn,
        onSelect: function onSelect(row, isSelect) {
          _this5.props.selectRow.onSelect(row, isSelect, _this5.pinnedTableRef.current.state.selectedRowKeys);
        }
      });
      if (!isPinned && pinTable) {
        selectRowProp = {};
      }
      return /*#__PURE__*/_react.default.createElement(_reactBootstrapTable.BootstrapTable, {
        ref: tableOptions.isMovableColumn ? this.movableTableRef : this.pinnedTableRef,
        bodyContainerClass: useNoDataCont ? 'noDataCont' : this.props.bodyContainerClass,
        bodyStyle: this.props.bodyStyle,
        bordered: this.props.bordered,
        cellEdit: finalCellEdit,
        columns: columns,
        condensed: this.props.condensed,
        containerClass: this.props.containerClass,
        containerStyle: this.props.containerStyle,
        data: pagedata || data,
        expandableRow: this.props.expandableRow,
        expandColumnOptions: this.props.expandColumnOptions,
        expandComponent: this.props.expandComponent,
        footer: this.props.footer,
        footerData: this.props.footerData,
        headerContainerClass: this.props.headerContainerClass,
        headerStyle: this.props.headerStyle,
        height: this.props.height,
        hover: this.props.hover,
        pagination: false,
        options: tableOptions,
        tableBodyClass: this.props.tableBodyClass,
        tableContainerClass: this.props.tableContainerClass,
        tableHeaderClass: this.props.tableHeaderClass,
        tableStyle: this.props.tableStyle,
        trClassName: this.props.trClassName || this.onFormatTrClass,
        width: this.props.width,
        selectRow: loading ? {} : selectRowProp,
        deleteRow: this.props.deleteRow,
        remote: this.props.pinTable ? true : this.props.remote
      }, columns);
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(o, isPinned) {
      var _this6 = this;
      var hideTooltipOnClick = this.props.hideTooltipOnClick;
      var _this$state3 = this.state,
        columns = _this$state3.columns,
        loading = _this$state3.loading,
        dividerHeight = _this$state3.dividerHeight;
      var headertext = '';
      var useToolTip = false;
      var headerSelector = document.querySelectorAll('.headertext');
      if (headerSelector && headerSelector.length > 0) {
        for (var i = 0; i < headerSelector.length; i += 1) {
          if (headerSelector[i].innerText && o.text && headerSelector[i].innerText.toLowerCase() === o.text.toLowerCase()) {
            if (headerSelector[i].offsetWidth < headerSelector[i].scrollWidth) {
              useToolTip = true;
            }
          }
        }
      }
      if (useToolTip) {
        headertext = /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
          placement: "top",
          overlay: /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, {
            className: _styles.default.tooltip
          }, o.text)
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "headertext"
        }, _lodash.default.toUpper(o.text)));
      } else {
        headertext = /*#__PURE__*/_react.default.createElement("span", {
          className: "headertext"
        }, _lodash.default.toUpper(o.text));
      }
      return /*#__PURE__*/_react.default.createElement(_reactBootstrapTable.TableHeaderColumn, {
        caretRender: typeof o.sortFunc === 'function' || o.dataSort ? o.customCaret || defaultCaret : null,
        className: o.colHeaderCss,
        columnClassName: "".concat(o.colCss, " custom-td"),
        customEditor: this.renderCustomEditor(o),
        headerAlign: o.headerAlign,
        hidden: o.hidden,
        dataAlign: o.dataAlign,
        dataField: o.key,
        editable: o.editable,
        dataFormat: function dataFormat(cell, row, ed, index) {
          var cellref = /*#__PURE__*/_react.default.createRef();
          if (o.colCss === 'allow-overflow') {
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "cell-container"
            }, o.formatter(cell, row));
          }
          var renderFormatter = function renderFormatter() {
            if (loading && !(o.hidden || o.isIconColumn || o.key === null)) {
              return /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
                variant: "text"
              });
            }
            if (o.formatter) {
              return o.formatter(cell, row, ed, index, _reactBootstrap.Overlay, "".concat(columns.indexOf(o)).concat(index), _reactBootstrap.Tooltip, _reactBootstrap.OverlayTrigger);
            }
            return cell;
          };
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "cell-container",
            ref: cellref,
            role: "presentation",
            onMouseOver: function onMouseOver(e) {
              _this6.handleTooltip(e, cellref, cell, index, o.tooltipFormatter, row, o.tooltipOff);
            },
            onMouseOut: function onMouseOut() {
              _this6.setState({
                showTooltip: false
              });
            },
            onClick: function onClick() {
              if (hideTooltipOnClick) {
                _this6.setState({
                  showTooltip: false
                });
              }
            },
            onFocus: function onFocus() {
              return null;
            },
            onBlur: function onBlur() {
              return null;
            }
          }, renderFormatter());
        },
        dataSort: o.dataSort,
        isKey: o.isPrimaryKey,
        key: o.key,
        searchable: o.searchable,
        sortFunc: o.sortFunc || function () {
          return null;
        } // non-sort function to not override onsortchange
        ,
        thStyle: o.thStyle,
        tdStyle: o.tdStyle,
        width: o.width
      }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, headertext, o.helpTipContent && /*#__PURE__*/_react.default.createElement(_helpTip.default, {
        content: o.helpTipContent,
        position: o.helpTipPosition
      }), isPinned ? /*#__PURE__*/_react.default.createElement("div", {
        className: "divider",
        style: {
          height: this.setDividerHeight(dividerHeight)
        }
      }) : null));
    }
  }, {
    key: "renderPinnedColumns",
    value: function renderPinnedColumns() {
      var _this7 = this;
      var _this$props4 = this.props,
        customRowAction = _this$props4.customRowAction,
        onEdit = _this$props4.onEdit;
      var _this$state4 = this.state,
        data = _this$state4.data,
        loading = _this$state4.loading;
      var useNoDataStyle = false;
      if (!loading && (!data || data && !data.length > 0)) {
        useNoDataStyle = true;
      }
      var pinnedColumns = (0, _toConsumableArray2.default)(this.pinnedColumns);

      // Add editable cell to last column
      if ((onEdit || customRowAction !== undefined) && this.movableColumns.length === 0) {
        pinnedColumns[pinnedColumns.length - 1] = this.formatEditColumn(pinnedColumns[pinnedColumns.length - 1]);
      }
      var tableHeaders = pinnedColumns.map(function (col) {
        return _this7.renderHeader(col, true);
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: !useNoDataStyle ? 'pinned-columns-container' : ' pinned-columns-container noDataPinHeader'
      }, /*#__PURE__*/_react.default.createElement("div", {
        key: "pinned-column-table"
      }, pinnedColumns.length !== 0 && this.renderTable(tableHeaders, {
        noDataText: ' '
      }, true)));
    }

    /**
     * Render icon columns
     * @returns {Element}
     */
  }, {
    key: "renderPinnedIconColumns",
    value: function renderPinnedIconColumns() {
      var _this8 = this;
      var customRowAction = this.props.customRowAction;
      if (this.iconColumn.length === 0) {
        return null;
      }

      // Add editable cell to last column
      if ((this.props.onEdit || customRowAction !== undefined) && this.movableColumns.length === 0) {
        this.iconColumn[this.iconColumn.length - 1] = this.formatEditColumn(this.iconColumn[this.iconColumn.length - 1]);
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pinned-icon-columns-container"
      }, this.iconColumn.map(function (column) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "pinned-icon-column",
          key: column.key
        }, _this8.renderTable(_this8.renderHeader(column), {
          noDataText: ' '
        }));
      }));
    }
  }, {
    key: "renderMovableColumns",
    value: function renderMovableColumns() {
      var _this9 = this;
      if (this.movableColumns.length === 0) {
        return null;
      }
      var customRowAction = this.props.customRowAction;
      var columns = (0, _toConsumableArray2.default)(this.movableColumns);

      // Add editable cell to first column
      if (this.props.onEdit || customRowAction !== undefined) {
        columns.unshift({
          key: null,
          text: '',
          dataSort: false,
          width: '56px',
          editable: false,
          hidden: this.state.loading,
          colCss: 'sticky-edit-icon-cell',
          tdStyle: {
            textAlign: 'left',
            position: 'sticky',
            left: 'calc(100% - 50px)',
            zIndex: 2,
            pointerEvents: 'none'
          }
        });
        columns[0] = this.formatEditColumn(columns[0]);
      }
      var tableHeaders = columns.map(function (col) {
        return _this9.renderHeader(col);
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "movable-columns-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "current-columns"
      }, this.renderTable(tableHeaders, {
        noDataText: ' ',
        isMovableColums: true
      })));
    }
  }, {
    key: "renderColumns",
    value: function renderColumns() {
      var _this$state5 = this.state,
        loading = _this$state5.loading,
        columns = _this$state5.columns,
        data = _this$state5.data;
      this.movableColumns = columns.filter(function (column) {
        return !column.pinned && !column.isIconColumn;
      });
      this.pinnedColumns = columns.filter(function (column) {
        return column.pinned && !column.isIconColumn;
      });
      this.iconColumn = columns.filter(function (column) {
        return column.isIconColumn;
      });
      if (this.pinnedColumns.length === 0) {
        this.movableColumns = columns.filter(function (column) {
          return !column.isPrimaryKey;
        });
        this.pinnedColumns = columns.filter(function (column) {
          return column.isPrimaryKey && !column.isIconColumn;
        });
      }
      this.pinnedColumns = this.pinnedColumns.map(function (c, index) {
        if (index === 0) {
          return _objectSpread(_objectSpread({}, c), {}, {
            isPrimaryKey: true
          });
        }
        return _objectSpread(_objectSpread({}, c), {}, {
          isPrimaryKey: false
        });
      });

      // In case no primary keys in movable columns. Need one so table doesn't break.
      if (this.movableColumns.filter(function (c) {
        return c.isPrimaryKey;
      }).length === 0) {
        this.movableColumns.push({
          key: 'tempid',
          hidden: true,
          isPrimaryKey: true
        });
      }
      var useNoDataText = false;
      if (!loading && (!data || data && !data.length > 0)) {
        useNoDataText = true;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "table-container search-results"
      }, useNoDataText ? /*#__PURE__*/_react.default.createElement("div", {
        className: "pinTableNoDataText"
      }, this.props.options.noDataText || 'There is no data to display') : null, this.renderPinnedIconColumns(), this.renderPinnedColumns(), this.renderMovableColumns());
    }
  }, {
    key: "renderExternalPagination",
    value: function renderExternalPagination(showPagination) {
      var _this10 = this;
      var _this$props5 = this.props,
        serverPagination = _this$props5.serverPagination,
        serverTotalRecords = _this$props5.serverTotalRecords,
        _onChangeCurrentPage = _this$props5.onChangeCurrentPage,
        _onChangeSizePerPage = _this$props5.onChangeSizePerPage,
        serverPage = _this$props5.serverPage,
        options = _this$props5.options,
        t = _this$props5.t,
        rowsRange = _this$props5.rowsRange,
        showRowsPerPage = _this$props5.showRowsPerPage;
      var ret = showPagination ? /*#__PURE__*/_react.default.createElement(_index.default, {
        data: this.state.data,
        serverPagination: serverPagination,
        serverTotalRecords: serverTotalRecords,
        serverPage: serverPage,
        sizePerPage: options.sizePerPage,
        onChangeSizePerPage: function onChangeSizePerPage(activePageSize) {
          return _onChangeSizePerPage(activePageSize);
        },
        pageRange: this.props.options.paginationSize,
        rowsRange: rowsRange,
        showRowsPerPage: showRowsPerPage,
        onChangeCurrentPage: function onChangeCurrentPage(activePage) {
          return _onChangeCurrentPage(activePage);
        },
        returnData: function returnData(returndata, activePage) {
          _this10.setState({
            pagedata: returndata,
            activePage: activePage
          });
        },
        t: t
      }) : null;
      return ret;
    }
  }, {
    key: "renderBasicTable",
    value: function renderBasicTable() {
      var _this11 = this;
      var tableHeaders = _lodash.default.map(this.state.columns, function (o) {
        return _this11.renderHeader(o);
      });
      return this.renderTable(tableHeaders);
    }
  }, {
    key: "render",
    value: function render() {
      var pagination = this.props.pagination;
      var pinTableContainerStyle = {
        display: 'flex'
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.props.noTableClass ? '' : CLASS_NAME
      }, !this.props.pinTable ? /*#__PURE__*/_react.default.createElement("span", null, this.renderBasicTable(), this.renderExternalPagination(pagination, this.state.data)) : /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
        className: PINTABLE_CLASS_NAME,
        style: pinTableContainerStyle
      }, this.renderColumns(this.state.data)), this.renderExternalPagination(pagination, this.state.data, this.state.pagedata)), /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Overlay, {
        placement: this.state.tooltipOrientation || this.props.tooltipOrientation,
        show: this.state.showTooltip,
        className: "tooltip",
        target: this.state.currtarget
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tooltip, {
        id: "celltooltip",
        className: this.props.tooltipStyle ? this.props.tooltipStyle : _styles.default.tooltip
      }, this.state.cellinfo))));
    }
  }]);
  return DataTable;
}(_react.Component);
exports.PureDataTable = DataTable;
DataTable.propTypes = {
  bodyContainerClass: _propTypes.default.string,
  bodyStyle: _propTypes.default.shape({}),
  tooltipStyle: _propTypes.default.shape({}),
  bordered: _propTypes.default.bool,
  cellEdit: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({})]),
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    caretRender: _propTypes.default.func,
    className: _propTypes.default.string,
    colCss: _propTypes.default.string,
    headerAlign: _propTypes.default.oneOf(['left', 'center', 'right', 'start', 'end']),
    hidden: _propTypes.default.bool,
    dataAlign: _propTypes.default.oneOf(['left', 'center', 'right', 'start', 'end']),
    dataField: _propTypes.default.string,
    dataFormat: _propTypes.default.func,
    dataSort: _propTypes.default.bool,
    formatter: _propTypes.default.func,
    isPrimaryKey: _propTypes.default.bool,
    key: _propTypes.default.string,
    searchable: _propTypes.default.bool,
    sortFunc: _propTypes.default.func,
    text: _propTypes.default.string,
    width: _propTypes.default.string,
    helpTipContent: _propTypes.default.string,
    helpTipPosition: _propTypes.default.shape({})
  })).isRequired,
  condensed: _propTypes.default.bool,
  containerClass: _propTypes.default.string,
  containerStyle: _propTypes.default.shape({}),
  data: _propTypes.default.instanceOf(Array),
  deleteRow: _propTypes.default.bool,
  expandableRow: _propTypes.default.func,
  expandColumnOptions: _propTypes.default.shape({
    expandColumnVisible: _propTypes.default.bool,
    expandColumnComponent: _propTypes.default.func,
    columnWidth: _propTypes.default.number
  }),
  expandComponent: _propTypes.default.func,
  footer: _propTypes.default.bool,
  footerData: _propTypes.default.instanceOf(Array),
  headerContainerClass: _propTypes.default.string,
  headerStyle: _propTypes.default.shape({}),
  height: _propTypes.default.string,
  hover: _propTypes.default.bool,
  listMode: _propTypes.default.shape({}),
  noTableClass: _propTypes.default.bool,
  onEdit: _propTypes.default.func,
  onChangeCurrentPage: _propTypes.default.func,
  onChangeSizePerPage: _propTypes.default.func,
  options: _propTypes.default.shape({
    defaultSortName: _propTypes.default.string,
    defaultSortOrder: _propTypes.default.string,
    deleteRow: _propTypes.default.bool,
    noDataText: _propTypes.default.string,
    onDeleteRow: _propTypes.default.func,
    onSortChange: _propTypes.default.func,
    onRowClick: _propTypes.default.func,
    paginationSize: _propTypes.default.number,
    sizePerPage: _propTypes.default.number,
    page: _propTypes.default.number
  }),
  pagination: _propTypes.default.bool,
  pinTable: _propTypes.default.bool,
  requesting: _propTypes.default.bool,
  selectRow: _propTypes.default.shape({
    onSelect: _propTypes.default.func
  }),
  serverPagination: _propTypes.default.bool,
  serverPage: _propTypes.default.number,
  serverTotalRecords: _propTypes.default.number,
  sortChangeCallback: _propTypes.default.func,
  tableBodyClass: _propTypes.default.string,
  tableContainerClass: _propTypes.default.string,
  tableHeaderClass: _propTypes.default.string,
  tableStyle: _propTypes.default.shape({}),
  trClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  tooltipOrientation: _propTypes.default.string,
  width: _propTypes.default.string,
  remote: _propTypes.default.bool,
  customRowAction: _propTypes.default.shape({}),
  onCustomFormatTrClass: _propTypes.default.func,
  hideTooltipOnClick: _propTypes.default.bool,
  t: _propTypes.default.func,
  showRowsPerPage: _propTypes.default.bool,
  rowsRange: _propTypes.default.instanceOf(Array)
};
DataTable.defaultProps = {
  bodyContainerClass: '',
  bodyStyle: {},
  tooltipStyle: null,
  bordered: false,
  cellEdit: false,
  condensed: false,
  containerClass: '',
  containerStyle: {},
  data: [],
  deleteRow: false,
  expandableRow: function expandableRow() {
    return false;
  },
  expandColumnOptions: {},
  expandComponent: function expandComponent() {
    return 'expanded';
  },
  footer: false,
  footerData: [],
  headerContainerClass: '',
  headerStyle: {},
  height: '',
  hover: false,
  listMode: {},
  noTableClass: false,
  onEdit: null,
  onChangeCurrentPage: function onChangeCurrentPage(num) {
    return num;
  },
  onChangeSizePerPage: function onChangeSizePerPage(num) {
    return num;
  },
  options: {
    alwaysShowAllBtns: true,
    defaultSortName: null,
    defaultSortOrder: null,
    deleteRow: false,
    firstPage: '«',
    hideSizePerPage: true,
    lastPage: '»',
    nextPage: '›',
    noDataText: 'There is no data to display',
    onDeleteRow: function onDeleteRow() {
      return [];
    },
    onRowClick: function onRowClick() {
      return null;
    },
    paginationPanel: null,
    paginationShowsTotal: null,
    paginationSize: 5,
    page: null,
    prePage: '‹',
    sizePerPage: 20
  },
  pagination: false,
  pinTable: false,
  requesting: false,
  selectRow: {},
  serverPagination: false,
  serverPage: 1,
  serverTotalRecords: 0,
  sortChangeCallback: function sortChangeCallback() {
    return null;
  },
  tableBodyClass: 'datatable-custom-body',
  tableContainerClass: '',
  tableHeaderClass: 'datatable-custom-header',
  tableStyle: {},
  trClassName: '',
  tooltipOrientation: 'bottom',
  width: '',
  remote: false,
  customRowAction: undefined,
  onCustomFormatTrClass: undefined,
  hideTooltipOnClick: false,
  t: function t(x) {
    return x;
  },
  rowsRange: [5, 10, 15, 20],
  showRowsPerPage: false
};
var _default = (0, _resizeable.default)(DataTable);
exports.default = _default;